import {Box, Grid, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import * as React from "react";
import {useTranslation} from "react-i18next";

const AuthBanner = () => {

    const {t} = useTranslation()

    return (
        <Box sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',

            '@media (max-width: 1000px)': {
                display: 'none'
            }
        }}>

            <Stack alignItems={'center'} mb={2}>
                <img
                    src={require('../../assets/media/images/Crqlar Transparent Logo claim.png')} alt={'Logo'}
                    style={{
                        maxWidth: 400,
                        objectFit: 'contain',
                    }}
                />
            </Stack>


            <Typography sx={{mb: 4}} variant={'subtitle2'}>
                {t("Trusted by Europe's leading hoteliers")}
            </Typography>

            <Grid container spacing={4} alignItems={'center'} justifyContent={'center'}>
                <Grid item>
                    <img
                        src={'https://cdn.prod.website-files.com/668fbc1db388fda7e66e3d42/69d4f2c473664adcb411a655_edelweiss-grau-watzmann-schw-hintergrundlogo-mit-silhouette-2024-05-08_logo-grau-e1718269137203.png'}
                        style={{width: 200}}/>
                </Grid>

                <Grid item>
                    <img
                        src={'https://assets-global.website-files.com/63b5f3d4137f2a4a2b71bbbe/63b74ba9e7fa61c8f3c49cfd_post-lech-crqlar.png'}
                        style={{width: 200}}/></Grid>
                <Grid item>
                    <img
                        src={'https://assets-global.website-files.com/63b5f3d4137f2a4a2b71bbbe/6404fad4ec8bf72be870de4c_forsthofgut-natur-hotel-crqlar-p-500.png'}
                        style={{width: 200}}/>
                </Grid>

                <Grid item> <img
                    src={'https://assets-global.website-files.com/63b5f3d4137f2a4a2b71bbbe/63b74ba9b271ee118d681955_hotel-sonnenburg-lech-crqlar.png'}
                    style={{width: 200}}/></Grid>
                <Grid item> <img
                    src={'https://cdn.prod.website-files.com/668fbc1db388fda7e66e3d42/6a730a53ea975ed0be8b8b1e_image001.png'}
                    style={{width: 200}}/></Grid>
                <Grid item> <img
                    src={'https://assets-global.website-files.com/63b5f3d4137f2a4a2b71bbbe/63b74ba992c60973923c18fa_hotel-schwarzer-adler-st-anton-crqlar.png'}
                    style={{width: 200}}/></Grid>
                <Grid item> <img
                    src={'https://assets-global.website-files.com/63b5f3d4137f2a4a2b71bbbe/63b74ba97f3626498b584d9f_grand-hotel-lienz-crqlar.png'}
                    style={{width: 200}}/></Grid>
            </Grid>

        </Box>
    )
}

export default AuthBanner
